import React, { useContext, useEffect, lazy, Suspense } from "react";
import { Routes, Route, useNavigate, Navigate } from "react-router-dom";
import { GLOBAL_CONTEXT } from "../../../types/store";
import Context from "../../../store/context";
import Loading from "../../../components/Loading";

const Clients = lazy(() => import("../clientList"));
const ApproverGroupConfig = lazy(() => import("../ApproverGroupConfig"));
const ClientHomePage = lazy(() => import("../ClientHomePage"));
const SubscriptionConfig = lazy(() => import("../SubscriptionConfig"));

const ClientManager: React.FC = () => {
  const navigate = useNavigate();
  const {
    globalState: { userDetails },
  } = useContext<GLOBAL_CONTEXT>(Context);
  useEffect(() => {
    if (userDetails?.userType !== "admin") {
      navigate("/sfdr", { replace: true });
    }
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = `/adminResources/css/main.css?t=${new Date()
      .getTime()
      .toString()}`;
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);
  return (
    <Routes>
      <Route index element={<Clients />} />
      <Route
        path=":clientId"
        element={
          <Suspense fallback={<Loading />}>
            <ClientHomePage />
          </Suspense>
        }
      >
        <Route index element={<Navigate to="approvers" />} />
        <Route
          path="approvers"
          element={
            <Suspense fallback={<Loading />}>
              <ApproverGroupConfig />
            </Suspense>
          }
        />
        <Route
          path="subscription"
          element={
            <Suspense fallback={<Loading />}>
              <SubscriptionConfig />
            </Suspense>
          }
        />
      </Route>
    </Routes>
  );
};

export default ClientManager;
